import { Script } from 'gatsby';
import React from 'react';
import { generateClickHandler } from './helpers/generateClickHandler';

type Props = {
  domain: string;
  script: string;
};

export const SmartScriptHandler = ({ domain, script }: Props) => {
  const handleClickString = generateClickHandler(script, domain);
  if (!handleClickString) {
    console.error(
      'Invalid AppsFlyer SmartScript configuration. Please check the script and domain.',
    );
    return null;
  }

  return (
    <Script type="text/javascript" id="appsflyer-smartscript-handler" defer>
      {`
          window.addEventListener('click', ${handleClickString});
        `}
    </Script>
  );
};
